// src/SocietyMember/Tasks/Tasks.jsx
import React, { useState } from "react";
import SocietySideNav from "../navBarSocietyDashbard/navBarSocietyDashbard";
import { useSociety } from "../context/SocietyContext";
import { createTask } from "../../../api/societyRequest";

const Tasks = () => {
  const { tasks, setTasks, members, role } = useSociety();
  const [title, setTitle] = useState("");
  const [assignedTo, setAssignedTo] = useState("");

  const canAssign =
    role === "CORE_COUNCIL" ||
    role === "HEAD" ||
    role === "CO_HEAD";

  const submit = async () => {
    if (!canAssign) return alert("No permission");

    const res = await createTask({ title, assignedTo });
    setTasks([...tasks, res.data]);
  };

  return (
    <>
      <SocietySideNav />
      <div className="p-8">
        <h1 className="text-2xl mb-6">Tasks</h1>

        {canAssign && (
          <div className="mb-6">
            <input
              placeholder="Task title"
              onChange={(e) => setTitle(e.target.value)}
            />
            <select onChange={(e) => setAssignedTo(e.target.value)}>
              <option value="">Assign To</option>
              {members.map((m) => (
                <option key={m.user._id} value={m.user._id}>
                  {m.user.name}
                </option>
              ))}
            </select>
            <button onClick={submit}>Assign Task</button>
          </div>
        )}

        {tasks.map((t) => (
          <div key={t._id} className="mb-2">
            {t.title} → {t.assignedTo.name} ({t.status})
          </div>
        ))}
      </div>
    </>
  );
};

export default Tasks;
